var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", { ref: "generateSignatureForm" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "custom-background" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "name",
                                  "custom-error-msg": "El campo es requerido",
                                  error: errors[0],
                                  label: "Nombre:"
                                },
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "lastName",
                                  "custom-error-msg": "El campo es requerido",
                                  error: errors[0],
                                  label: "Primer Apellido:"
                                },
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "secondLastName",
                                  "custom-error-msg": "El campo es requerido",
                                  error: errors[0],
                                  label: "Segundo Apellido:"
                                },
                                model: {
                                  value: _vm.model.secondLastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "secondLastName", $$v)
                                  },
                                  expression: "model.secondLastName"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "charge",
                                  "custom-error-msg": "El campo es requerido",
                                  error: errors[0],
                                  label: "Puesto:"
                                },
                                model: {
                                  value: _vm.model.chargeName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "chargeName", $$v)
                                  },
                                  expression: "model.chargeName"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "area",
                                  "custom-error-msg": "El campo es requerido",
                                  error: errors[0],
                                  label: "Área:"
                                },
                                model: {
                                  value: _vm.model.area,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "area", $$v)
                                  },
                                  expression: "model.area"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                attrs: {
                                  id: "participantType",
                                  clearable: true,
                                  "custom-error-msg": "El campo es requerido",
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  label: "Tipo de Participante:",
                                  options: _vm.participantTypes,
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.model.participantType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "participantType", $$v)
                                  },
                                  expression: "model.participantType"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "d-flex justify-content-end" }, [
                _c(
                  "div",
                  [
                    _c("action-button", {
                      staticClass: "mr-2 px-3",
                      attrs: {
                        i: "fas fa-times-circle",
                        text: "Cancelar",
                        variant: "outline-danger"
                      },
                      on: { click: _vm.cancel }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("action-button", {
                      staticClass: "mr-2 px-3",
                      attrs: {
                        i: "fas fa-file-plus",
                        text: "Añadir",
                        variant: "success"
                      },
                      on: { click: _vm.add }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }